import React from 'react';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import {FormattedMessage, IntlShape} from 'react-intl';

class JSONTableDrop extends React.Component {
	static propTypes = {
		connectDropTarget: PropTypes.func,
		dragEndFn: PropTypes.func,
		draggingFn: PropTypes.func,
		draggingIndex: PropTypes.number,
		dropFn: PropTypes.func,
		isDetailView: PropTypes.bool,
		isOver: PropTypes.bool,
	}

	static defaultProps = {
		isDetailView: false
	};

	render() {
		return this.props.connectDropTarget(
			<small className={"JSONTableDropColumn jsonTable jsonTableNew empty"}>
				<span className="emptyText"><i className={"fa " + (this.props.isDetailView ? "fa-list" : "fa-table")}></i>&nbsp;
					{
						this.props.isDetailView
						? <FormattedMessage defaultMessage="Add rows to here" id="jsonTable.empty.rows" />
						: <FormattedMessage defaultMessage="Add colums to here" id="jsonTable.empty.columns" />
					}
				</span>
			</small>
		);
	}
}

const dropHandler = {
	hover(props, monitor, component) {
		props.draggingFn(monitor.getItem(), 0);
	},
	drop(props, monitor, component) {
		props.dropFn(monitor.getItem(), 0);
	}
};

function dropActions(connect, monitor) {
	return {
		canDrop: monitor.canDrop(),
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver(),
	};
}

export default DropTarget('JSONTableDragColumn', dropHandler, dropActions)(JSONTableDrop);
